// IN_THE_KITCHEN = 0,
// DOING = 1,
// PREPARED = 2,
// DELIVERED = 3,
// WAITING = 4,
// CANCELED = 5,
// CHANGED = 6,
// PAUSED = 7,
// WAITING_PAYMENT = 8,
// PAID = 9

export const getOrderStatus = (status: number) => {
  switch (status) {
    case 0:
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
      return 0
    case 7:
    case 8:
      return 1
    default:
      return 2
  }
}

export const getOrderPadStatusToPay = (status: number) => {
  switch (status) {
    case 0:
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
    case 6:
    case 7:
      return 0
    case 8:
      return 1
    default:
      return null
  }
}
